// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1q3_F","copyContainer":"Footer_copyContainer__3YkLw","linkAppContainer":"Footer_linkAppContainer__258fm","linkContainer":"Footer_linkContainer__1ixqa"};